let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2Oecn")).then(() => parcelRequire('6XvEn'));